import React, { Component } from 'react';
import { connect } from 'react-redux'
import { phoneIconChange, pause, agenda, conference, transferCall, leaveConference } from '../../../Images/Images';
import { closeSvg } from '../../../Images/GenericSVG';
import { hangUp } from '../../../Images/CallSpaceHeaderSVG';
import { Singleton } from '../../../js/Singleton';
import { STRATEGIES_ASSISTED_TRANSFER } from '../../../js/Strategies/StrategiesAssistedTransfer';
import { STRATEGIES_INTEGRATION_ASSISTED_TRANSFER } from '../../../js/Strategies/StrategiesIntegrationAssistedTransfer'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { validateOnlyNumbers } from '../../../js/helpers/Utils/Validations';
import { actionPreviewRecord, messageAssistedTransferCall, messageHangUp } from '../../../redux/actions/A_messages_to_SM';
import { newAssistedTransferState } from '../../../redux/actions/A_assisted_transfer';
import { HANG_UP_SUBACTIONS, ASSISTED_TRANSFER, ASSISTED_TRANSFER_SUBACTION, RECORD_STATE } from '../../../constants';
import CallingAssitedTransfer from './CallingAssistedTransfer.jsx';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { hidePhone } from '../../../js/helpers/Utils/formats';
import { changePreviewRecordStatus, removeRecord } from '../../../redux/actions/A_preview';
import { setTransferInProgress } from '../../../redux/actions/A_preview_transfer';

class AssistedTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newCallNumber: "",
      isInConference: this.props.isInConference,
      transferring: false
    };
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    this.information = this.props.data
    this.data = {
      sPhone: "",
      reference: "",
      callId: ""
    };
  }

  componentDidMount() {
    (this.props.assistedTransfer.currentState === ASSISTED_TRANSFER.ON_CONFERENCE_CALL ? this.setState({ transferring: true }) : this.setState({ transferring: false }));
  }

  componentWillReceiveProps(nextProps) {
    if (STRATEGIES_ASSISTED_TRANSFER[nextProps.assistedTransfer.currentState]) {
      STRATEGIES_ASSISTED_TRANSFER[nextProps.assistedTransfer.currentState](this);
    }
    if (nextProps.messagesIntegrations.dataMessageIntegration && (nextProps.messagesIntegrations !== this.props.messagesIntegrations)) {
      if (STRATEGIES_INTEGRATION_ASSISTED_TRANSFER[nextProps.messagesIntegrations.dataMessageIntegration.action]) {
        STRATEGIES_INTEGRATION_ASSISTED_TRANSFER[nextProps.messagesIntegrations.dataMessageIntegration.action](this, nextProps.messagesIntegrations.dataMessageIntegration);
      }
    }
  }
  dialNumber(phone) {
    if (!this.state.isInConference) {
      this.sendintegrationErrorMessage("Invalid function at the current state, set up a conference to add more calls");
    }
    else if (this.state.isInConference) {
      this.setState({ newCallNumber: phone })
      this.callNewNumber();
    }
  }

  callNewNumber() {
    this.props.newAssistedTransferState(ASSISTED_TRANSFER.ON_CONFERENCE_CALL)
  }

  leaveTransfer() {
      let _this = this;
      setTimeout(() => { 
        _this.props.actionPreviewRecord(
          { 
              process: 15,
              camId: this.props.previewReducer.selectedRecord.camId,
              callOutId:this.props.previewReducer.selectedRecord.callOutId,
              callId: this.props.previewReducer.selectedRecord.callId,
              fReplacementJob: this.props.previewReducer.previewType === 1 ? 1 : 0,
              fMultipleJob: 1
          })
       }, 101);
    setTimeout(() => {
      this.props.removeRecord(this.props.previewReducer.selectedRecord.callOutId);
    }, 200); 
    this.props.setTransferInProgress(false);
  }
  mainCall(CallIndex) {
    if (this.information[CallIndex].active === false) {
      this.data.reference = this.information[CallIndex].flag;
      this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
      if (this.information[CallIndex].title === this.language.getText("CallControlGUIAssistedCallTransfermainCall")) {
        let _this = this;
        setTimeout(() => { _this.props.newAssistedTransferState(ASSISTED_TRANSFER.MAIN_CALL) }, 100);
      }
    } else {
      this.sendintegrationErrorMessage("Invalid function at the current state, you are currently on the selected call");
    }
  }
  assistedTransferCall() {
    if (this.information[0].active && !this.state.isInConference) {
      this.data.reference = "transfer";
      if(this.sharedData.getDataPreviewPro().dialingMode === 1){
        this.data.agentDest = this.props.previewTransfer.login;
      }
     setTimeout(() => {
      this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
     }, 50); 
     if(this.props.previewReducer.simultaneosRecs){
      this.leaveTransfer();
     }
    } else {
      this.sendintegrationErrorMessage("Invalid function at the current state, you must return to the main call");
    }
  }
  hangUpSecondCall() {
    this.data.reference = "hangup";
    setTimeout(() => {
      this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
    }, 50);
    this.props.setTransferInProgress(false)
  }
  startconference() {
    if (this.information[0].active) {
      this.props.newAssistedTransferState(ASSISTED_TRANSFER.ON_CONFERENCE);
    } else {
      this.sendintegrationErrorMessage("Invalid function at the current state, you must return to the main call");
    }
  }
  sendintegrationErrorMessage(messageToSend) {
    const error = { code: 7, message: messageToSend }
    let integrationMessage = { client: "galatea", data: error, action: "onError" };
    SingletonWebSocket.send(integrationMessage);
  }
  leaveConference() {
    if (this.state.isInConference) {
      this.data.reference = "leave";
      if(this.sharedData.getDataPreviewPro().dialingMode === 1){
        this.data.agentDest = this.props.previewTransfer.login;
      }
      this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
      if(this.props.previewReducer.simultaneosRecs){
        this.leaveTransfer();
       }
    } else {
      this.sendintegrationErrorMessage("Invalid function at the current state, you are not in a conference");
    }
  }
  hangUpConference() {
    this.props.messageHangUp(HANG_UP_SUBACTIONS.CALL,0);
    this.sharedData.setCallConferencetoZero();
  }
  hangUpCallingConference() {
    this.data.reference = "hangupOther";
    this.data.callId = this.sharedData.getConferenceCallID();
    this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
  }
  hangUpOther(i) {
    this.data.reference = "hangupOther";
    this.data.callId = this.information[i].callId;
    this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
  }
  hangupSecondCallConference() {
    this.data.reference = "hangupSecondCall";
    this.data.callId = "";
    this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
  }
  handelKeyPress(e) {
    if (e.key === 'Enter') {
      this.callNewNumber();
    }
    else {
      validateOnlyNumbers(e);
    }
  }

  renderListCalls() {
    const isHidePhone = this.sharedData.getGeneralPermissions()[223];

    return this.information.map((item, i) =>
      <div className={"callItemTransfer " + (item.active ? "activeCall" : "waitingCall")} key={"callList" + i} onClick={() => this.mainCall(i)}>
        <div className="circle1"></div>
        <div className="circle2"></div>
        <div className="callItemTitle">
          <input type="text"
            placeholder={item.title}//{this.language.getText('searchForMatchesButton')}
            className={"titleCallTransfer " + (this.state.isInConference ? "onConf" :"")}
            value={this.state.searchTransfer} />
          <p className="waiting">{!item.active ? this.language.getText("CallControlGUIAssistedCallTransferwaiting") : ""}</p>
        </div>
        <div className="callItemData" >
          <img className="imgSide" src={item.active ? phoneIconChange : pause} alt="icon"></img>
          <p className="textRight">{hidePhone(isHidePhone, item.number)}</p>
        </div>
        <div className="buttonHangUpTransferCall"
          onClick={() => {
            switch (i) {
              case 0:
                this.hangUpConference();
                break;
              case 1:
                (this.state.isInConference ? this.hangupSecondCallConference() : this.hangUpSecondCall());
                break;
              default:
                this.hangUpOther(i);
            }
          }
          }>{hangUp}
        </div>
      </div>
    );
  }

  renderAddCall() {
    return (
      <div className="addNumberTransfer">
        <img className="addNumberIcon" src={agenda} alt="icon" onClick={() => this.props.onOpenAgenda()}></img>
        <div className={"addNumberContainer " + (this.state.newCallNumber !== "" ? "active" : "")}>
          <img className={"imgSide " + (this.state.newCallNumber !== "" ? "active" : "")} src={phoneIconChange} alt="icon"></img>
          <input type="text"
            placeholder={this.language.getText("CallControlGUIAssistedCallTransferenterNumber")}//{this.language.getText('searchForMatchesButton')} 
            className={"textRight " + (this.state.newCallNumber !== "" ? "active" : "")}
            value={this.state.newCallNumber}
            onChange={event => { this.setState({ newCallNumber: event.target.value }) }}
            onKeyPress={this.handelKeyPress.bind(this)} />
          {this.state.newCallNumber !== "" ?
            <div className="buttonClearText" onClick={() => this.setState({ newCallNumber: "" })}>
              {closeSvg}
            </div> : ""}
        </div>
        <img className={"addNumberCall " + (this.state.newCallNumber !== "" ? "active" : "")}
          src={phoneIconChange} alt="icon"
          onClick={() => this.callNewNumber()}>
        </img>
      </div>);
  }

  render() {
    const addCall = this.sharedData.getDataPreviewPro().dialingMode !== 1;
    return (
      <div className="transferAssistedContainer">
        <div className={"CallingAssitedTransfer"}>
          {this.state.transferring &&
            <CallingAssitedTransfer
              phoneNumberTransfer={this.sharedData.getConferenceNewNumber()}
              hangUpTransfer={() => this.hangUpCallingConference()}
            />
          }
        </div>
        <div className={"transferSelectionContainer " + (this.state.transferring ? "active" : "")}>
          <div className="callsList">
            {this.renderListCalls()}
            {this.state.isInConference && addCall && this.renderAddCall()}
          </div>
          <div className="optionsTransfer">
            {this.state.isInConference ?
              <div className={"optionTransfer blueColor " + (this.sharedData.getextraCallsConference() ? "disabled" : "")} onClick={() => this.leaveConference()}>
                <img className="imgSide" src={leaveConference} alt="icon"></img>
                <p className="textRight onConf">{this.language.getText("CallControlGUIAssistedCallTransferleaveConference")}</p>
              </div> :
              <div>
                <div className={"optionTransfer greenColor " + (!this.information[0].active || !this.props.allowsConference ? "disabled" : "")} onClick={() => this.startconference()}>
                  <img className="imgSide" src={conference} alt="icon"></img>
                  <p className="textRight">{this.language.getText("CallControlGUIAssistedCallTransferconference")}</p>
                </div>
                <div className={"optionTransfer blueColor " + (!this.information[0].active ? "disabled" : "")} onClick={() => this.assistedTransferCall()}>
                  <img className="imgSide" src={transferCall} alt="icon"></img>
                  <p className="textRight">{this.language.getText("CallControlGUIAssistedCallTransfertransfer")}</p>
                </div>
              </div>
            }
            <div className="optionTransfer redColor" onClick={() => (this.state.isInConference ? this.hangUpConference() : this.hangUpSecondCall())}>{hangUp}</div>
          </div>
        </div>
      </div>
    );
  }
};
function mapStateToProps(state) {
  return {
    assistedTransfer: state.assistedTransfer,
    messagesIntegrations: state.messagesIntegrations,
    previewReducer: state.preview
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    messageAssistedTransferCall: (action,data) => { dispatch(messageAssistedTransferCall(action,data)); },
    messageHangUp: (subaction,callOutId) => { dispatch(messageHangUp(subaction,callOutId)); },
    newAssistedTransferState: (message) => { dispatch(newAssistedTransferState(message)); },
    removeRecord: (callOutId) => { dispatch(removeRecord(callOutId)) },
    changePreviewRecordStatus: (callOutId) => {dispatch(changePreviewRecordStatus({callOutId:callOutId, status:RECORD_STATE.DEFAULT, messageStatus: null}))},
    actionPreviewRecord: (data) => {dispatch(actionPreviewRecord(data)) },
    setTransferInProgress: (flag) => {dispatch(setTransferInProgress(flag))}
  })
}
export default AssistedTransfer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistedTransfer);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/AssistedTransfer.jsx